import {Component} from '@angular/core';

@Component({
    selector: 'p-gentle',
    templateUrl: './p-gentle.component.html',
})
export class ParagraphGentleComponent {

}
